import { PropTypes } from "prop-types";
import { RouterProvider } from "react-aria-components";
import {
	createBrowserRouter,
	Outlet,
	useHref,
	useNavigate,
} from "react-router";

import { errorHandler } from "../helpers/errorHandler";
import { ErrorPage } from "./components/ErrorPage";
import { FormLayout } from "./components/FormLayout";
import { LoadingFallback } from "./components/LoadingFallback";
import { PostFormLayout } from "./components/PostFormLayout";
import { RootLayout } from "./components/RootLayout";
import { ADVERTISER_ROUTE } from "./helpers/constants";

const useAbsoluteHref = (path) => {
	const relative = useHref(path);

	if (
		path.startsWith("https://") ||
		path.startsWith("http://") ||
		path.startsWith("mailto:")
	) {
		return path;
	}

	return relative;
};

const Root = ({ children }) => {
	const navigate = useNavigate();

	return (
		// https://react-spectrum.adobe.com/react-aria/routing.html
		<RouterProvider navigate={navigate} useHref={useAbsoluteHref}>
			{children}
		</RouterProvider>
	);
};

Root.propTypes = {
	children: PropTypes.node,
};

const routes = [
	{
		path: "/",
		element: (
			<Root>
				<Outlet />
			</Root>
		),
		errorElement: <ErrorPage />,
		hydrateFallbackElement: <LoadingFallback />,
		children: [
			{
				path: ADVERTISER_ROUTE,
				element: (
					<RootLayout>
						<Outlet />
					</RootLayout>
				),
				children: [
					{
						path: "",
						element: (
							<FormLayout>
								<Outlet />
							</FormLayout>
						),
						children: [
							{
								index: true,
								lazy: () => import("./steps/Info"),
							},
							{
								path: "contact",
								lazy: () => import("./steps/Contact"),
							},
						],
					},
					{
						path: "",
						element: (
							<PostFormLayout>
								<Outlet />
							</PostFormLayout>
						),
						children: [
							{
								path: "continue",
								lazy: () => import("./steps/ContinueWithLocalMoveProvider"),
							},
							{
								path: "success",
								lazy: () => import("./steps/Success"),
							},
						],
					},
					// {
					// 	path: "*",
					// 	element: <NotFound />,
					// },
				],
			},
		],
	},
];

export const router = createBrowserRouter(routes, {
	onError: errorHandler,
});
